import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import ui from './modules/ui'
import questions from './modules/questions'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        ui,
        questions
    }
})

export default store

/**
 * Check current resolution
 */
const checkIsMobile = () => {
    const isMobile = window.matchMedia('(max-width: 1024px)').matches
    store.dispatch('ui/setViewportHeight', window.innerHeight)
    store.dispatch('ui/setIsMobile', isMobile)
}

/**
 * Check on every resize, mostly for development purpose
 */
window.addEventListener('resize', checkIsMobile)

/**
 * Initial mobile check
 */
checkIsMobile()
